(function () {
  const ZOOM = 2.6;
  const HAT_TRANSFORM = 'translateY(24%)';
  const HAT_ORIGIN = 'center center';
  const CHART_RE = /color\s*chart/i;
  const ZOOM_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 19 19" aria-hidden="true">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M4.667 7.94a.5.5 0 0 1 .499-.501l5.534-.014a.5.5 0 1 1 .002 1l-5.534.014a.5.5 0 0 1-.5-.5" clip-rule="evenodd"/>' +
    '<path fill="currentColor" fill-rule="evenodd" d="M7.926 4.665a.5.5 0 0 1 .501.498l.014 5.534a.5.5 0 1 1-1 .003l-.014-5.534a.5.5 0 0 1 .499-.501" clip-rule="evenodd"/>' +
    '<path fill="currentColor" fill-rule="evenodd" d="M12.832 3.03a6.931 6.931 0 1 0-9.802 9.802 6.931 6.931 0 0 0 9.802-9.802M2.323 2.323a7.931 7.931 0 0 1 11.296 11.136l4.628 4.628a.5.5 0 0 1-.707.707l-4.662-4.662A7.932 7.932 0 0 1 2.323 2.323" clip-rule="evenodd"/>' +
    '</svg>';

  function isChartModal(node) {
    return !!(
      node &&
      node.closest &&
      node.closest('.tpo_modal-container, .tpo_modal-content, .tpo_modal-background, [class*="tpo_modal"]')
    );
  }

  function isChartLightbox(node) {
    return !!(node && node.closest && node.closest('.uc-chart-lightbox'));
  }

  function isProductGalleryImg(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.closest('.thumbnail-list, .thumbnail-slider, .product__thumbnails')) {
      return false;
    }
    return !!(
      img.closest('.product-media-container.media-type-image .product__media') ||
      img.closest('.product-media-modal__content') ||
      (img.classList.contains('image-magnify-lightbox') &&
        img.closest('.product-media-container, .product-media-modal__content'))
    );
  }

  function isHatFramed(img) {
    return !!(img && (img.dataset.ucHatFrame === '1' || img.classList.contains('uc-hat-live--framed')));
  }

  function chartModalFrom(node) {
    if (!node || !node.closest) return null;
    const modal = node.closest('.tpo_modal-container, [class*="tpo_modal-container"]');
    if (!modal) return null;
    const heading =
      modal.querySelector('.tpo_modal-heading') ||
      modal.querySelector('h2, h3, [class*="tpo_modal-heading"]');
    if (!heading || !CHART_RE.test(heading.textContent || '')) return null;
    return modal;
  }

  function zoomImg(target) {
    if (!target || !target.closest) return null;

    const opener = target.closest(
      '.product__modal-opener--image, .product-media-container.media-type-image'
    );
    if (opener && !isChartModal(opener)) {
      const nested = opener.querySelector('.product__media img, img.image-magnify-lightbox, img');
      if (nested && isProductGalleryImg(nested)) return nested;
    }

    const img = target.tagName === 'IMG' ? target : target.closest('img');
    if (!img) return null;
    if (isChartLightbox(img)) return img;
    if (isChartModal(img)) return img;
    if (isProductGalleryImg(img)) return img;
    return null;
  }

  function ensureLightbox() {
    var lb = document.getElementById('uc-chart-lightbox');
    if (lb) return lb;

    lb = document.createElement('div');
    lb.id = 'uc-chart-lightbox';
    lb.className = 'uc-chart-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Color chart zoom');
    lb.hidden = true;
    lb.innerHTML =
      '<div class="uc-chart-lightbox__dialog">' +
      '<button type="button" class="uc-chart-lightbox__close product-media-modal__toggle" aria-label="Close">' +
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17" aria-hidden="true">' +
      '<path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/>' +
      '</svg></button>' +
      '<p class="product-media-modal__hint" aria-hidden="true">' +
      '<span class="product-media-modal__hint-text uc-chart-lightbox__hint-desktop">(e.g., hover over the image to zoom)</span>' +
      '<span class="product-media-modal__hint-text uc-chart-lightbox__hint-mobile">(e.g., tap and drag to zoom)</span>' +
      '</p>' +
      '<div class="uc-chart-lightbox__content">' +
      '<div class="uc-chart-lightbox__stage">' +
      '<img class="uc-chart-lightbox__img" src="" alt="">' +
      '</div></div></div>';

    lb.querySelector('.uc-chart-lightbox__close').addEventListener('click', closeLightbox);
    lb.addEventListener('click', function (event) {
      if (event.target === lb) closeLightbox();
    });
    document.body.appendChild(lb);
    return lb;
  }

  function openLightbox(src, alt) {
    if (!src) return;
    var lb = ensureLightbox();
    var img = lb.querySelector('.uc-chart-lightbox__img');
    img.removeAttribute('width');
    img.removeAttribute('height');
    img.style.width = '';
    img.style.height = '';
    img.src = src;
    img.alt = alt || 'Color chart';
    reset(img);
    lb.hidden = false;
    lb.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  function closeLightbox() {
    var lb = document.getElementById('uc-chart-lightbox');
    if (!lb) return;
    var img = lb.querySelector('.uc-chart-lightbox__img');
    reset(img);
    if (img) {
      img.style.width = '';
      img.style.height = '';
    }
    lb.hidden = true;
    lb.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  function wrapChartImage(img, label) {
    if (!img || img.dataset.ucChartZoomReady === '1') return;

    var wrap = img.closest('.uc-chart-media-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'uc-chart-media-wrap product__modal-opener product__modal-opener--image';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
    }

    if (!wrap.querySelector('.uc-chart-zoom-btn')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'uc-chart-zoom-btn product__media-icon product__media-icon--lightbox motion-reduce';
      btn.setAttribute('aria-label', 'Open color chart zoom');
      btn.innerHTML = '<span class="svg-wrapper">' + ZOOM_ICON + '</span>';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openLightbox(img.currentSrc || img.src, img.alt || label);
      });
      wrap.appendChild(btn);
    }

    img.dataset.ucChartZoomReady = '1';
  }

  function addChartZoomUi() {
    document.querySelectorAll('.uc-chart-hint').forEach(function (hint) {
      if (!hint.closest('.tpo_modal-container, [class*="tpo_modal-container"]')) {
        hint.remove();
      }
    });

    document.querySelectorAll('.tpo_modal-container, [class*="tpo_modal-container"]').forEach(function (modal) {
      var heading =
        modal.querySelector('.tpo_modal-heading') ||
        modal.querySelector('h2, h3, [class*="tpo_modal-heading"]');
      if (!heading || !CHART_RE.test(heading.textContent || '')) return;

      var title = heading.querySelector('h3, h2') || heading;
      var label = (title.textContent || '').replace(/\s*\(.+\)\s*$/, '').trim();

      var hints = modal.querySelectorAll('.uc-chart-hint');
      hints.forEach(function (hint, index) {
        if (index > 0) hint.remove();
      });

      var hint = modal.querySelector('.uc-chart-hint');
      if (!hint) {
        hint = document.createElement('span');
        hint.className = 'uc-chart-hint';
      }
      hint.innerHTML =
        '<span class="uc-chart-hint__desktop">(e.g., hover over the image to zoom)</span>' +
        '<span class="uc-chart-hint__mobile">(e.g., tap and drag to zoom)</span>';
      if (hint.parentElement !== title) title.appendChild(hint);

      modal.querySelectorAll('img').forEach(function (img) {
        if (img.closest('.uc-chart-lightbox')) return;
        wrapChartImage(img, label);
      });
    });
  }

  var uiTimer = null;
  function scheduleChartUi() {
    clearTimeout(uiTimer);
    uiTimer = setTimeout(addChartZoomUi, 120);
  }

  function pointFromEvent(event) {
    if (event.touches && event.touches[0]) {
      return { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    return { x: event.clientX, y: event.clientY };
  }

  function setOrigin(img, event) {
    var rect = img.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var point = pointFromEvent(event);
    var x = ((point.x - rect.left) / rect.width) * 100;
    var y = ((point.y - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
    img.style.transform = 'scale(' + ZOOM + ')';
  }

  function reset(img) {
    if (!img) return;
    if (isHatFramed(img)) {
      img.style.transform = HAT_TRANSFORM;
      img.style.transformOrigin = HAT_ORIGIN;
    } else {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
    }
    img.classList.remove('uc-chart-zoom');
  }

  document.addEventListener(
    'mousemove',
    function (event) {
      var img = zoomImg(event.target);
      if (!img) return;
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'mouseover',
    function (event) {
      var img = zoomImg(event.target);
      if (!img) return;
      img.classList.add('uc-chart-zoom');
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var img = zoomImg(event.target);
      if (!img) return;
      var next = event.relatedTarget;
      if (next && zoomImg(next) === img) return;
      reset(img);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchstart',
    function (event) {
      var img = zoomImg(event.target);
      if (!img) return;
      img.classList.add('uc-chart-zoom');
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      var img = zoomImg(event.target);
      if (!img) return;
      setOrigin(img, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      reset(zoomImg(event.target));
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    function (event) {
      reset(zoomImg(event.target));
    },
    { passive: true }
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleChartUi);
  } else {
    scheduleChartUi();
  }
  document.addEventListener('shopify:section:load', scheduleChartUi);
  new MutationObserver(scheduleChartUi).observe(document.documentElement, { childList: true, subtree: true });
})();
